export const GET_CATEGORY_SUB_CATEGORIES = "GET_CATEGORY_SUB_CATEGORIES";
export const GET_CATEGORY_SUB_CATEGORY_BY_ID =
  "GET_CATEGORY_SUB_CATEGORY_BY_ID";
export const UPDATE_CATEGORY_SUB_CATEGORY = "UPDATE_CATEGORY_SUB_CATEGORY";
export const DELETE_CATEGORY_SUB_CATEGORY = "DELETE_CATEGORY_SUB_CATEGORY";
export const CREATE_CATEGORY_SUB_CATEGORY = "CREATE_CATEGORY_SUB_CATEGORY";
